import { NotFound } from '@zuruflex/ui';
import { useTranslation } from 'react-i18next';

/** The shared 404, worded for staff rather than for customers. */
export function NotFoundPage() {
  const { t } = useTranslation('admin');

  return (
    <NotFound
      title={t('notFound.title')}
      description={t('notFound.body')}
      homeLabel={t('notFound.back')}
    />
  );
}
